<template>
  <div class="createOrder">
    <!-- 页面标题 -->
    <div style="background: #fff; padding: 20px; margin: 0 0 10px;">
      <h2 style="margin: 0;">发起订单</h2>
    </div>

    <!-- 发起订单表单 -->
    <el-form ref="createOrderForm" :model="createOrderForm" label-width="120px">
      <!-- 第一步：选择客户 -->
      <el-card class="order-step-card" shadow="never">
        <div slot="header" class="clearfix">
          <span>第一步：选择客户账号</span>
        </div>
        <el-form-item label="客户账号:" required style="margin-top: 20px;">
          <el-select
            v-model="createOrderForm.admin_pay_id"
            placeholder="请选择客户账号"
            clearable
            filterable
            style="width: 300px"
            @change="handleAccountChange"
          >
            <div v-for="(item, index) in accountList" :key="index">
              <el-option :label="item.name" :value="item.id"></el-option>
            </div>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="账户折扣:" v-if="selectedAccount">
          <span
            v-if="selectedAccount.discount && selectedAccount.discount > 0 && selectedAccount.discount < 1"
            style="color: #f56c6c; font-weight: 600; font-size: 16px;"
          >{{ (selectedAccount.discount * 10).toFixed(1) }} 折 ({{ (selectedAccount.discount * 100).toFixed(0) }}%)</span>
          <span v-else style="color: #909399; font-size: 14px;">账户暂未设置折扣</span>
        </el-form-item> -->
      </el-card>

      <!-- 第二步：选择商品 -->
      <el-card class="order-step-card" shadow="never" style="margin-top: 20px;">
        <div slot="header" class="clearfix">
          <span>
            第二步：选择商品
            <el-button style=" padding: 3px 0" type="text" @click="handleSelectGoods">选品</el-button>
          </span>
        </div>

        <!-- 已选商品列表 -->
        <div v-if="selectedOrderGoods.length > 0">
          <CustomGoodsTable
            :tableData="selectedOrderGoods"
            :showBatchActions="true"
            @update-subtotal="handleUpdateSubtotal"
            @remove-goods="handleRemoveOrderGoods"
            @batch-remove="handleBatchRemoveGoods"
          />
        </div>
        <div v-else style="text-align: center; color: #999; padding: 40px 0;">请点击"选品"按钮选择商品</div>

        <!-- 费用统计 -->
        <div v-if="selectedOrderGoods.length > 0" class="cost-summary">
          <el-row :gutter="20">
            <el-col :span="12">
              <div class="cost-item">
                <span class="cost-label">商品总价 (cost):</span>
                <span class="cost-value">{{ orderTotalAmount.toFixed(2) }} 元</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="cost-item">
                <span class="cost-label">运费 (freightFee):</span>
                <span class="cost-value freight-fee">{{ freightFee.toFixed(2) }} 元</span>
                <span class="cost-hint">(商品总价小于69元收取6元运费)</span>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20" style="margin-top: 15px;">
            <el-col :span="12">
              <div class="cost-item">
                <span class="cost-label">优惠金额 (coupon_price):</span>
                <el-input-number
                  v-model="createOrderForm.coupon_price"
                  :min="0"
                  :max="orderTotalAmount"
                  :precision="2"
                  size="small"
                  style="width: 150px; margin-left: 10px;"
                  @change="calculateRealityCost"
                ></el-input-number>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="cost-item">
                <span class="cost-label">订单总价 (realityCost):</span>
                <span class="cost-value total-cost">{{ realityCost.toFixed(2) }} 元</span>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-card>

      <!-- 提交按钮 -->
      <div style="text-align: center; margin-top: 20px; background: #fff; padding: 20px;">
        <el-button type="primary" @click="submitCreateOrder" :loading="createOrderLoading">确认发起订单</el-button>
        <el-button @click="$router.back()">取消</el-button>
      </div>
    </el-form>

    <!-- 选品弹窗 -->
    <el-dialog
      title="选择商品"
      :visible.sync="dialogVisible_selectGoods"
      :close-on-click-modal="false"
      width="900px"
    >
      <div v-loading="selectDataLoading" :element-loading-text="loadingText">
        <el-form :inline="true" label-width="100px">
          <el-form-item label="商品编码: " style="margin: 10px" size="small">
            <el-input v-model="queryListForm.productCode" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item label="商品标题: " style="margin: 10px" size="small">
            <el-input v-model="queryListForm.productName" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-button
            class="addBtn"
            type="primary"
            @click="querygoodsList"
            size="small"
            v-waves
            style="margin: 10px 0"
            :loading="selectDataLoading"
          >筛选</el-button>
        </el-form>

        <el-transfer
          style="
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 20px;
          "
          v-model="selectedGoodsKeys"
          :titles="['可选商品', '已选商品']"
          :data="selectData"
          :props="{
            key: 'productCode',
            label: 'value',
          }"
        >
          <span slot-scope="{ option }">
            <el-tooltip class="item" effect="dark" :content="option.value" placement="top">
              <span>{{ option.value}}</span>
            </el-tooltip>
          </span>
        </el-transfer>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button class="cancelBtn" size="small" @click="dialogVisible_selectGoods = false">取 消</el-button>
        <el-button
          class="addBtn"
          size="small"
          type="primary"
          @click="confirmSelectGoods"
          :loading="selectDataLoading"
        >确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import CustomGoodsTable from "@/components/CustomGoodsTable/index.vue";
import { addOrder, getGoodsDiscount } from "@/services/mall/order";
import { selectGoods } from "@/services/mall/goods.js"; //自选商品接口
import { selectGoods as selectJdGoods } from "@/services/mall/goodsJd.js"; //京东商品接口
import { mapState } from "vuex";
import { queryCustomerAccountList } from "@/services/admin_user/index.js";

export default {
  components: {
    CustomGoodsTable
  },
  async created() {
    this.selectAccountList();
  },
  data() {
    return {
      createOrderForm: {
        admin_pay_id: "", // 下单客户ID
        status: 1, // 默认待支付状态
        coupon_price: 0 // 优惠金额
      },
      selectedAccount: null, // 选中的账户信息
      selectedOrderGoods: [], // 已选择的订单商品
      createOrderLoading: false,

      // 选品相关数据
      dialogVisible_selectGoods: false,
      selectData: [], // 可选择的商品数据
      selectedGoodsKeys: [], // 已选择的商品key列表
      selectDataLoading: false,
      loadingText: "正在加载商品数据...",
      shouldStopLoading: false,
      queryListForm: {
        productCode: "",
        productName: ""
      },

      accountList: []
    };
  },
  computed: {
    ...mapState(["userInfo"]),

    // 计算订单总金额
    orderTotalAmount() {
      return this.selectedOrderGoods.reduce((total, item) => {
        return total + parseFloat(item.price || 0) * (item.num || 0);
      }, 0);
    },

    // 计算运费 (商品总价小于69付6元运费)
    freightFee() {
      return this.orderTotalAmount < 69 ? 6 : 0;
    },

    // 计算订单总价 = 商品总价 + 运费 - 优惠金额
    realityCost() {
      const total =
        this.orderTotalAmount +
        this.freightFee -
        (this.createOrderForm.coupon_price || 0);
      return total > 0 ? total : 0;
    }
  },
  methods: {
    async selectAccountList() {
      const { data, code } = await queryCustomerAccountList({
        pageNumber: 1,
        pageSize: 1000
      });
      if (code === 200) {
        this.accountList = data.map(item => {
          return {
            ...item,
            name: item.alias_name,
            id: item.id,
            discount: item.discount || 1
          };
        });
      }
    },

    /* 切换账户 */
    async handleAccountChange(admin_id) {
      if (!admin_id) {
        this.selectedAccount = null;
        return;
      }

      // 设置选中的账户信息
      this.selectedAccount = this.accountList.find(
        item => item.id === admin_id
      );

      // 如果已选择了商品，需要重新计算商品价格
      if (this.selectedOrderGoods.length > 0) {
        await this.refreshGoodsPrice();
      }
    },

    /* 刷新商品价格 */
    async refreshGoodsPrice() {
      if (
        !this.createOrderForm.admin_pay_id ||
        this.selectedOrderGoods.length === 0
      ) {
        return;
      }

      try {
        const result = await getGoodsDiscount({
          admin_id: this.createOrderForm.admin_pay_id,
          goods: this.selectedOrderGoods
        });

        if (result.code === 200 && result.data) {
          // 更新商品价格，确保数据类型正确
          this.selectedOrderGoods = result.data.map(item => ({
            ...item,
            price: parseFloat(item.price || 0),
            marketPrice: parseFloat(item.marketPrice || item.price || 0),
            num: item.num || 1
          }));
          this.$message.success("商品价格已更新");
        }
      } catch (error) {
        console.error("刷新商品价格失败:", error);
        this.$message.error("刷新商品价格失败");
      }
    },

    /* 计算实际支付金额 */
    calculateRealityCost() {
      // realityCost是computed属性，会自动计算
      // 这个方法主要用于触发UI更新
      this.$forceUpdate();
    },

    /* 打开选品弹窗 */
    handleSelectGoods() {
      this.dialogVisible_selectGoods = true;
      this.querygoodsList(); // 初始化商品列表
    },

    /* 从两个商品接口获取可用商品列表 */
    async querygoodsList() {
      this.shouldStopLoading = false;
      this.selectDataLoading = true;
      this.loadingText = "正在加载商品数据...";

      try {
        if (this.shouldStopLoading) {
          return;
        }

        // 合并现有已选择的商品（保持原有选择）
        const existingSelectedGoods = this.selectData.filter(item =>
          this.selectedGoodsKeys.includes(item.productCode)
        );

        // 同时调用自选商品接口和京东商品接口
        const selfGoodsPromise = selectGoods({
          pageNumber: 1,
          pageSize: 50,
          status: 0,
          ...this.queryListForm
        });

        const jdGoodsPromise = selectJdGoods({
          pageNumber: 1,
          pageSize: 50,
          productName:
            this.queryListForm?.productCode ||
            this.queryListForm?.productName ||
            ""
        });

        const [selfGoodsResult, jdGoodsResult] = await Promise.all([
          selfGoodsPromise,
          jdGoodsPromise
        ]);

        if (this.shouldStopLoading) {
          return;
        }

        let allGoods = [];

        // 处理自选商品数据
        if (selfGoodsResult.code === 200 && selfGoodsResult.data) {
          const selfGoods = selfGoodsResult.data.map(item => ({
            productCode: item.productCode,
            value: `自选-${item.productCode} - ${item.productName}`,
            source: 2,
            id: item.id,
            productName: item.productName,
            price: parseFloat(item.price || 0),
            marketPrice: parseFloat(item.marketPrice || item.price || 0),
            coverImg: item.coverImg,
            introduce: item.introduce,
            min_pay_num: item.min_pay_num || 1
          }));
          allGoods = allGoods.concat(selfGoods);
        }

        // 处理京东商品数据
        if (jdGoodsResult.code === 200 && jdGoodsResult.data) {
          const jdGoods = jdGoodsResult.data.map(item => ({
            productCode: item.productCode || item.skuId,
            value: `${item.productCode || item.skuId} - ${item.productName ||
              item.name}`,
            source: 1,
            id: item.productCode || item.skuId,
            productName: item.productName || item.name,
            price: parseFloat(item.price || 0),
            marketPrice: parseFloat(item.marketPrice || item.price || 0),
            coverImg: item.coverImg,
            introduce: item.introduce,
            min_pay_num: item.min_pay_num || 1
          }));
          allGoods = allGoods.concat(jdGoods);
        }

        if (this.shouldStopLoading) {
          return;
        }

        // 去重合并，保证productCode唯一性
        const existingIds = existingSelectedGoods.map(item => item.productCode);
        const newGoods = allGoods.filter(
          item => !existingIds.includes(item.productCode)
        );

        const combinedGoods = [...existingSelectedGoods, ...newGoods];

        // 最终去重，保留第一个出现的商品编码
        const uniqueGoods = [];
        const seenProductCodes = new Set();

        combinedGoods.forEach(item => {
          if (!seenProductCodes.has(item.productCode)) {
            seenProductCodes.add(item.productCode);
            uniqueGoods.push(item);
          }
        });

        this.selectData = uniqueGoods;
      } catch (error) {
        console.error("查询商品列表失败:", error);
        if (!this.shouldStopLoading) {
          this.$message.error("查询商品列表失败");
        }
      } finally {
        this.selectDataLoading = false;
      }
    },

    /* 确认选择商品 */
    async confirmSelectGoods() {
      // 根据选择的商品key，从selectData中获取完整的商品信息
      const selectedGoods = this.selectData.filter(item =>
        this.selectedGoodsKeys.includes(item.productCode)
      );

      // 转换为订单商品格式
      const orderGoods = selectedGoods.map(item => ({
        productCode: item.productCode,
        productName: item.productName,
        price: parseFloat(item.price || 0),
        marketPrice: parseFloat(item.marketPrice || item.price || 0),
        num: item.min_pay_num || 1,
        source: item.source,
        coverImg: item.coverImg,
        id: item.id,
        introduce: item.introduce,
        min_pay_num: item.min_pay_num || 1
      }));

      this.selectedOrderGoods = orderGoods;
      this.dialogVisible_selectGoods = false;
      this.$message.success(`已选择 ${orderGoods.length} 个商品`);

      // 如果已选择账户，刷新商品价格
      if (this.createOrderForm.admin_pay_id) {
        await this.refreshGoodsPrice();
      }

      console.log("this.selectedOrderGoods ", this.selectedOrderGoods);
    },

    /* 移除订单商品（单个删除） */
    handleRemoveOrderGoods(index) {
      const removedItem = this.selectedOrderGoods[index];
      this.selectedOrderGoods.splice(index, 1);
      // 同时从selectedGoodsKeys中移除
      const keyIndex = this.selectedGoodsKeys.findIndex(
        key => key === removedItem.productCode
      );
      if (keyIndex > -1) {
        this.selectedGoodsKeys.splice(keyIndex, 1);
      }
    },

    /* 批量删除订单商品 */
    handleBatchRemoveGoods(indices) {
      // 按索引倒序排列，从后往前删除，避免索引错乱
      indices.forEach(index => {
        const removedItem = this.selectedOrderGoods[index];
        // 从selectedGoodsKeys中移除
        const keyIndex = this.selectedGoodsKeys.findIndex(
          key => key === removedItem.productCode
        );
        if (keyIndex > -1) {
          this.selectedGoodsKeys.splice(keyIndex, 1);
        }
        // 从商品列表中移除
        this.selectedOrderGoods.splice(index, 1);
      });
    },

    /* 更新小计（数量变化时触发） */
    handleUpdateSubtotal(index, item) {
      // 当数量变化时，会自动重新计算orderTotalAmount（computed属性）
      console.log("商品数量更新:", index, item);
    },

    /* 提交创建订单 */
    async submitCreateOrder() {
      // 表单验证
      if (!this.createOrderForm.admin_pay_id) {
        this.$message.error("请选择客户账号");
        return;
      }
      if (this.selectedOrderGoods.length === 0) {
        this.$message.error("请至少选择一个商品");
        return;
      }

      // 验证商品价格和数量
      for (let item of this.selectedOrderGoods) {
        if (!item.price || item.price <= 0) {
          this.$message.error(
            `商品 ${item.productName} 的价格不能为空或小于等于0`
          );
          return;
        }
        if (!item.num || item.num <= 0) {
          this.$message.error(
            `商品 ${item.productName} 的数量不能为空或小于等于0`
          );
          return;
        }
      }

      // 二次确认
      try {
        await this.$confirm(
          `确认为客户 ${this.selectedAccount?.name ||
            ""} 发起订单吗？订单总价：${this.realityCost.toFixed(2)} 元`,
          "确认发起订单",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }
        );
      } catch {
        return; // 用户取消
      }

      this.createOrderLoading = true;

      try {
        const orderData = {
          status: 1, // 新订单默认待支付
          admin_pay_id: this.createOrderForm.admin_pay_id, // 企业主账户ID
          goods: this.selectedOrderGoods,
          createUser: this.userInfo.id,
          cost: this.orderTotalAmount, // 商品总价
          freightFee: this.freightFee, // 运费
          coupon_price: this.createOrderForm.coupon_price || 0, // 优惠金额
          realityCost: this.realityCost, // 实际支付金额
        };

        const result = await addOrder(orderData);

        if (result.code === 200) {
          this.$message.success("订单创建成功！");
          // 跳转回订单列表页面
          this.$router.push("/management/mallGoods/order");
        }
      } catch (error) {
        console.error("创建订单失败:", error);
      } finally {
        this.createOrderLoading = false;
      }
    }
  }
};
</script>

<style scoped lang="less">
.createOrder {
  width: 100%;
}

// 发起订单相关样式
.order-step-card {
  background: #fff;

  .el-card__header {
    background-color: #f5f7fa;
    border-bottom: 1px solid #ebeef5;

    .clearfix {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
}

// 费用统计样式
.cost-summary {
  margin-top: 30px;
  padding: 20px;
  background-color: #f9f9f9;
  border-radius: 6px;
  border: 1px solid #ebeef5;

  .cost-item {
    display: flex;
    align-items: center;
    padding: 10px 0;

    .cost-label {
      font-size: 14px;
      color: #606266;
      font-weight: 500;
      min-width: 150px;
    }

    .cost-value {
      font-size: 16px;
      font-weight: 600;
      color: #303133;
      margin-left: 10px;

      &.freight-fee {
        color: #e6a23c;
      }

      &.total-cost {
        color: #f56c6c;
        font-size: 18px;
      }
    }

    .cost-hint {
      font-size: 12px;
      color: #909399;
      margin-left: 10px;
    }
  }
}

// 选品弹窗样式
::v-deep .el-transfer-panel {
  width: 100%;
}

::v-deep .el-transfer__buttons {
  padding: 0 30px;
}
</style>
